var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3432_1152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.193 74.5143C110.18 106.657 77.6241 126.219 45.4771 118.204C13.3436 110.19 -6.21809 77.6324 1.79886 45.4918C9.80878 13.3451 42.3646 -6.21803 74.5016 1.7954C106.646 9.80884 126.207 42.3702 118.192 74.5149L118.193 74.5143H118.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9947 16L59.4043 18.0054V76.1922L59.9947 76.7812L87.0038 60.8159L59.9947 16Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9942 16L32.9844 60.8159L59.9942 76.7812V48.5389V16Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9929 81.895L59.6602 82.3008V103.028L59.9929 103.999L87.0186 65.938L59.9929 81.895Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9942 103.999V81.895L32.9844 65.938L59.9942 103.999Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9941 76.7813L87.0033 60.816L59.9941 48.5391V76.7813Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9844 60.816L59.9942 76.7813V48.5391L32.9844 60.816Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3432_1152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.dc0a6bc5.svg";
export { ForwardRef as ReactComponent };